import { z } from 'zod';

export const MaskFormSchema = z.object({
  updatedAt: z.string().optional(),
  largeUrl: z.string().min(1, 'Big size mask is required'),
  smallUrl: z.string().min(1, 'Small size mask is required'),
  transparentUrl: z.string().min(1, 'No background mask is required'),
  name: z
    .string()
    .min(3, 'Mask name must be at least 3 characters long')
    .regex(/^[a-zA-Z0-9 ]+$/, {
      message: 'Only letters and numbers are allowed',
    })
    .max(100, 'Mask name cannot exceed 100 characters'),
});
